// extracted by mini-css-extract-plugin
module.exports = {"Search":"Search_Search__2wNw2"};